import React, { useState } from 'react'
import * as h from '../../helpers/helpers';
import { lu } from '../../data/reportData';
import Spinner from '../spinner/Spinner';
import { useReportStateSnapshot } from '../../store/store';
import { TITLE, TAB, TAB_PROJECT, H1, H1_TX, H2, TXR_B, TXR_I, TXC_B, TXC_B1, TX_BI, TXC_I, TXC_I1, CK, CK_H2, CK1, CK1_I, YN1  } from "../../styles/urar-styles";
import { IMAGE_1, IMAGE_MAP, COMMENTARY, EXHIBITS, TABLE, TITLE_ADD, SUM_HD, TB_SUB_H1_R } from "../../styles/urar-styles";
import {ADDD_SUMMARY, ADDD} from './ADDD';
import { CONTACTS, PROPERTY_DATA_REPORT } from './ContactInformation';
import { DWELLINGS } from './DwellingExterior';
import { OUTBUILDINGS } from './Outbuildings';
import { OVERALL_LIST } from './OverallList';
import SALES_COMPARISON from './SalesComparisonApproach';
import RENTAL_INFORMATION from './RentalInformation';
import INCOME_APPROACH from './IncomeApproach';
import COST_APPROACH from './CostApproach';
import { END_NOTES } from './EndNotes';
import { SIGNATURE } from './Signature';
import ShowWarningsModal from '../common/ShowWarningsModal';

export default function REPORT() {
	const [warningsPopup, setWarningsPopup] = useState({ show: false, warnings: [] });
	var reportState = useReportStateSnapshot();

	//console.log("Report: ", reportState.loadingCount, reportState.loaded, reportState.ReportName);

	if (reportState.loadingCount > 0) return (<Spinner />);

	if (!warningsPopup.show && global.ptr.warnings.length > 0) {
		setWarningsPopup({show: true, warnings: global.ptr.warnings});
	}

	function handleWarningsCancel() {
		global.ptr.warnings = [];
		setWarningsPopup({show: false});
	}

	return (
		<>
		<ShowWarningsModal
			open = {warningsPopup.show}
			warnings = {warningsPopup.warnings}
			onCancel={() => handleWarningsCancel()}
		/>

		<div className='scroll mr-12'>
			<div className='report-container mpr'>
				<div className='w-full mb-[36px]'>
					<TITLE title="Uniform Residential Appraisal Report" />
					<TITLE_ADD title={lu("1.000")} />
				</div>
				<SUM_HD />
				<div className='col2'>
					<div>
						<TXR_B title="Opinion of Market Value" value={lu("1.001")} />
					</div>
					<div>
						<TXR_B title="Market Value Condition" value={lu("1.009")} />
					</div>
				</div>
				{ lu("1.002") &&
					<TXC_B title="Final Value Condition Statement" value={lu("1.002")} />
				}
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Effective Date of Appraisal" value={lu("1.003")} />
						<TXR_B title="Assignment Reason" value={lu("1.004")} />
						<TXR_B title="Borrower Name" value={lu("1.005")} />
						<TXR_B title="Current Owner of Public Record" value={lu("1.006")} />
						<TXR_B title="Contract Price" value={lu("1.007")} />
						<TXR_B title="Listing Status" value={lu("1.008")} />
					</div>
					<div>
						<TXR_B title="Property Valuation Method" value={lu("1.010")} />
						<TXR_B title="Appraiser Name" value={lu("1.011")} />
					</div>
				</div>

				<H1 title="Property Description" />

				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Construction Method" value={lu("1.012")} />
						<TXR_B title="AttachmentType" value={lu("1.013")} />
						<TXR_B title="Structure Design" value={lu("1.014")} />

						<CK1 title="Planned Unit Development (PUD)" value={lu("1.015")} yn />
						<CK1 title="Condominium" value={lu("1.016")} />
						<CK1 title="Cooperative" value={lu("1.017")} />
						<CK1 title="Condop" value={lu("1.018")} />
						<CK1 title="Observed Project Deficiencies" value={lu("1.019")} />
						<CK1 title="Subject Site Ownded in Common" value={lu("1.020")} bottom />

						<TXR_B title="Units Excluding ADUs" value={lu("1.021")} />
						<TXR_B title="Accessory Dwelling Units" value={lu("1.022")} />
						<TXR_B title="Property Rights Appraised" value={lu("1.023")} />

						<CK1 title={["Is the highest and best use of the subject property as\n", "improved (or as proposed per plans and specifications)\n", "the present use?"]} value={lu("1.024")} bottom yn/>

						<TXR_B title="Property Restrictions" value={lu("1.025")} />
						<TXR_B title="Encroachment" value={lu("1.026")} />
						<TXR_B title="Zoning Compliance" value={lu("1.027")} />
						<TXR_B title="HUD Data Plate Attached" value={lu("1.028")} />
						<TXR_B title="HUD Label Present for All Sections" value={lu("1.029")} />
					</div>
					<div>
						<TXR_B title="Overall Quality" value={lu("1.030")} />
						<TXR_B title="Overall Condition" value={lu("1.031")} />
						{/* picture goes here */}
						<IMAGE_1 category="PropertyPhoto"  />
					</div>
				</div>

				<ADDD_SUMMARY actionableOnly={true} /> 

				{ lu("1.082") &&
					<>
						<div className='col2 mt-3'>
							<div>
								<TXR_B title="As Is Overall Condition Rating" value={lu("1.082")} />
							</div>
							<div></div>
						</div>
						<TXC_I1 comment={"Existing condition of the property as of the effective date of this appraisal, excluding all required repairs, alterations, or inspections"} />
					</>
				}

				<TAB title="Assignment Information" />

				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Assignment Reason" value={lu("2.000")} />
						<TXR_B title="Borrower Name" value={lu("2.001")} />
						<TXR_B title="Seller Name" value={lu("2.002")} />
						<TXR_B title="Current Owner of Public Record" value={lu("2.003")} />
					</div>
					<div>
						<TXR_B title="Property Valuation Method" value={lu("2.004")} />

						<CK1 title={"Was a PropertyData Report used in lieu of an\ninspection?"} value={lu("2.005")} bottom={true} yn />
						<TXR_B title="Appraiser Fee" value={lu("2.006")} />
						<TXR_B title="AMC Fee" value={lu("2.007")} />
						<TXR_B title="Government Agency" value={lu("2.008")} />
						<TXR_B title="Investor requested Special Identification" value={lu("2.009")} />
					</div>
				</div>

				<H1 title="Contact Information" />
				<CONTACTS />
				<PROPERTY_DATA_REPORT />
				
				<COMMENTARY title="Assignment Information and Scope of Work Commentary" value={lu("2.061")} />
				<EXHIBITS title="Assignment Information Exhibits" id={["AssignmentExhibit"]} />

				<TAB title="Subject Property" />

				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Physical Address" value={lu("3.000")} />
						<TXR_B title="Alternate Physical Address" value={lu("3.001")} />
						<TXR_B title="County" value={lu("3.002")} />
						<TXR_B title="Neighborhood Name" value={lu("3.003")} />

						{/* YN1 required here because not all CK1s display  */}
						<YN1 />	
						<CK1 title="Planned Unit Development (PUD)" value={lu("3.010")} yn />
						<CK1 title="Condominium" value={lu("3.011")} />
						<CK1 title="Cooperative" value={lu("3.012")} />
						<CK1 title="Condop" value={lu("3.013")} />
						<CK1 title="Property on Native American Lands" value={lu("3.014")} />
						<CK1 title="Subject Site Ownded in Common" value={lu("3.015")} />
						<CK1 title="Homeowner Responsible for all Exterior Maintenance of Dwelling(s)" value={lu("3.016")} />
						<CK1 title="New Construction" value={lu("3.017")} bottom />

						<TXR_B title="Construction State" value={lu("3.018")} />
					</div>
					<div>
						<TXR_B title="Attachment Type" value={lu("3.004")} />
						<TXR_B title="Units Excluding ADUs" value={lu("3.005")} />
						<TXR_B title="Accessory Dwelling Units" value={lu("3.006")} />
						<TXR_B title="Dwellings Containing Units" value={lu("3.007")} />
						<TXR_B title="Special Tax Assessments" value={lu("3.008")} />

						<TXC_B1 title="Description of Special Tax Assessments and Impact to Value/Marketability" value={lu("3.009")} />
					</div>
				</div>

				{ !global.ptr.bCooperative &&
					<>
						<H1 title="Ownership Rights" />

						<div className='col2 mt-3'>
							<div>
								<TXR_B title="Property Rights Appraised" value={lu("3.019")} />
								<TXR_I title="Community Land Trust" value={lu("3.020")} />
								<TXR_I title="Native American Lands" value={lu("3.021")} />
								{ global.ptr.bGroundRent &&
								<>
									<TXR_B title="Ground Rent Annual Amount" value={lu("3.022")} />
									<TXR_I title="Renewable" value={lu("3.023")} />
									<TXR_I title="Term" value={lu("3.024")} />
									<TXR_I title="Expires" value={lu("3.025")} />
								</>
								}
							</div>
							<div>
								<TXR_B title="All Rights Included in Appraisal" value={lu("3.027")} />
								<TXR_I title="Rights Not Included" value={lu("3.028")} />
								<TXR_B title="Mineral Rights Leased" value={lu("3.029")} />
								<TXC_B1 title="Description of Rights Not Included" value={lu("3.030")} />
							</div>
						</div>
						<TXC_B1 title="Description of Ground Rent and Impact to Value/Marketability" value={lu("3.026")} />
					</>
				}

				<COMMENTARY title="Legal Description" value={lu("3.031")} />
				{/* could be picture */}

				<COMMENTARY title="Subject Property Commentary" value={lu("3.032")} />

				<EXHIBITS title="Subject Property Exhibits" id={["SubjectPropertyExhibit"]} />

				<TAB title="Site" />

				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Total Site Size" value={lu("4.000")} />
						<TXR_B title="Dimensions" value={lu("4.001")} />
					</div>
					<div>
						<TXR_B title="Number of Parcels" value={lu("4.002")} />
						<TXR_I title="Contiguous" value={lu("4.003")} />
						<TXR_I title="Elements Dividing Parcels" value={lu("4.004")} />
					</div>
				</div>

				{ !global.ptr.bCooperative && global.ptr.subProp.parcels && global.ptr.subProp.parcels.length > 0 &&
				<TABLE titles={["Assessor Parcel Number (APN)","APN Description","Parcel Size"]} widths={[360,360,360]} values={lu("4.005-07")} />
				}

				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Zoning" value=" " />
						<TXR_I title="Compliance" value={lu("4.008")} />
						<TXR_I title="Classification Code" value={lu("4.009")} />
						<TXR_I title="Classification Code Description" value={lu("4.010")} />
						<TXR_I title="Reasons Illegal" value={lu("4.011")} />
						<TXR_I title="Impact" value={lu("4.012")} />
						<TXR_I title={"Rebuildable to Current\nDensity/Use"} value={lu("4.013")} />
						<TXC_B1 title="Description of Zoning Compliance" value={lu("4.014")} />

						{ !global.ptr.bOwnedInCommon &&
						<>
							<TXR_B title="Property Use" value=" " />
							<TXR_I title="Primarily Residential" value={lu("4.015")} />
							<TXR_I title="Residential Use" value={lu("4.016")} />
							<TXR_I title="Non-Residential Use" value={lu("4.017")} />
							<TXR_I title="Non-Residential Modification" value={lu("4.018")} />

							<TXC_B1 title="Description of Non-Residential Use/Modification" value={lu("4.019")} />
						</>
						}
					</div>
					<div>
						<TXR_B title="Property Access" value=" " />
						<TXR_I title="Primary Access" value={lu("4.020")} />
						<TXR_I title="Street Type and Surface" value={lu("4.021")} />
						<TXR_I title="Known Maintenance Agreement" value={lu("4.022")} />
						<TXR_I title="Typical for Market" value={lu("4.023")} />

						<TXC_B1 title="Description of Property Access" value={lu("4.024")} />
					</div>
				</div>

				<H1 title="Site Influence" />

				<TABLE titles={["Influence","Proximity","Detail","Impact","Comment"]} widths={[208,208,208,190,266]} values={lu("4.024-29")} />

				<TXC_B title="Site Influence Commentary" value={lu("4.030")} />

				{ global.ptr.subSite.HasWaterFrontFeatures() &&
					<>
						<H2 title="Water Frontage with Private Access" />
						<div className='col2 mt-3'>
							<div>
								<TXR_B title="Total Linear Measurement" value={lu("4.031")} />
							</div>
							<div>
								<TXR_B title="Permanent Waterfront Feature" value={lu("4.032")} />
								<TXR_I title="Right to Build" value={lu("4.033")} />
							</div>
						</div>

						<TABLE titles={["Frontage","Name","Waterfront Access Rights","Access Depth"]} widths={[270,270,270,270]} values={lu("4.034-37")} />
						<TXC_B title="Water Frontage Commentary" value={lu("4.038")} />
					</>
				}

				<H1 title="View and Impact to Value/Marketability" />
				<TABLE titles={["View","Range of View","Impact"]} widths={[360,360,360]} values={lu("4.039-41")} />
				<TXC_B title="View Commentary" value={lu("4.042")} />

				<H1 title="Site Features and Impact to Value/Marketability" />
				<TABLE titles={["Feature","Impact","Detail","Comment"]} widths={[270,270,120,420]} values={lu("4.043-65")} />
				
				<TXC_B title="Site Features Commentary" value={lu("4.066")} />

				<H1 title="Utilities and Impact to Value/Marketability" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Broadband Internet Available" value={lu("4.067")} />
					</div>
					<div>
						<TXR_B title="Dwelling/Improvement within Utility Easement" value={lu("4.068")} />
					</div>
				</div>

				<TABLE titles={["","Public","Private","Detail","Private Utility\nImpact","Comment"]} widths={[168,96,96,168,168,384]} values={lu("4.069-98")} />

				<ADDD values={lu("4.099")} subtitle="(Site)" /> 

				{ !global.ptr.sowDetail.costApproachIndicator  && global.ptr.sowDetail.siteValueIndicator &&
				<>
					<H1 title="Site Valuation Methodology" />
					<div className='col2 mt-3'>
						<div>
							<TXR_B title="Opinion of Site Value" value={lu("4.105")} />
						</div>
						<div>
							<TXR_B title="Primary Site Valuation Method" value={lu("4.106")} />
						</div>
					</div>
					<TABLE titles={["#","Address","County","Data Source","Assessor Parcel Number (APN)","Site Size","Sale Date","Price"]} widths={[32,172,138,138,150,150,150,150]} values={lu("4.107-114")} />
					<TXC_B title="Reconciliation of Site Value" value={lu("4.115")} />
				</>
				}
				<COMMENTARY title="Site Commentary" value={lu("4.116")} />

				<EXHIBITS title="Site Exhibits" id={["LandComparableMap", "PropertyBoundaries", "NonResidentialUse", "PropertyAccess", "SiteInfluence", "PermanentWaterfrontFeature", "WaterFrontage", "View", "Encroachment", "SiteCharacteristic", "SiteExhibit"]} />

				{lu("5.000") !== "None" &&
				<>
					<TAB title="Disaster Mitigation" />
					<div className='col2 mt-3'>
						<div>
							<TXR_B title="Mitigation Feature" value={lu("5.000")} />
						</div>
					</div>
					
					<COMMENTARY title="Disaster Mitigation Commentary" value={lu("5.001")} />
					<EXHIBITS title="Disaster Mitigation Exhibits" id={["DisasterMitigationExhibit"]} />
				</>
				}
				{ global.ptr.subProp.energyEfficiencyAndGreen.EnergyExists() &&
				<>
					<TAB title="Energy Efficient and Green Features" />
					<TXR_B title="Known Renewable Energy Components" value={lu("6.000")} space />
					<TABLE titles={["Renewable Energy Component","Ownership","Financing Arrangement"]} widths={[360,360,360]} values={lu("6.001-3")} />

					<TXR_B title="Known Building Certifications" value={lu("6.004")} space />
					<TABLE titles={["Building Certification Organization","Certification","Year","Version","Rating"]} widths={[360,360,120,120,120]} values={lu("6.005-9")} />

					<TXR_B title="Known Efficiency Ratings" value={lu("6.010")} space />
					<TABLE titles={["Green/Energy Efficiency Rating Organization","Rating","Score"]} widths={[360,360,360]} values={lu("6.011-13")} />

					<H1 title="Energy Efficient and Green Features Impact to Value/Marketability" />
					<TXR_B title="Impact to Value/Marketability" value={lu("6.014")} space />
					<TXC_B title="Description" value={lu("6.015")} />

					<COMMENTARY title="Energy Efficient and Green Features Commentary" value={lu("6.016")} />

					<EXHIBITS title="Energy Efficient and Green Features Exhibits" id={["EnergyEfficientAndGreenFeaturesExhibit"]} />
				</>
				}
				
				<TAB title="Sketch" />
				<TXC_I comment={lu("7.000")} />
				<TXR_B title="Measurement Standard" value={lu("7.001")} space />

				<IMAGE_MAP category="SubjectPropertyImprovementSketch" />
				<IMAGE_MAP category="FloorPlan" />

				<COMMENTARY title="Sketch Commentary" value={lu("7.003")} />
				
				<DWELLINGS />

				<TAB title="Functional Obsolescence" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Functional Issues" value={lu("11.000")} />
					</div>
					<div>
					</div>
				</div>

				<COMMENTARY title="Functional Obsolesence Commentary" value={lu("11.001")} />

				<EXHIBITS title="Functional Obsolesence Exhibits" id={["FunctionalObsolescenceExhibits"]} />

				<OUTBUILDINGS />

				<TAB title="Vehicle Storage" />
				<TABLE titles={["Storage","RatNumber of Parking Spaces","Detail"]} widths={[360,360,360]} values={lu("13.001-03")} />

				<ADDD values={lu("13.005-09")} subtitle="(Vehicle Storage)" /> 

				<COMMENTARY title="Vehicle Storage Commentary" value={lu("13.010")} />

				<EXHIBITS title="Vehicle Storage Exhibits" values={lu("13.099")} />


				<TAB title="Subject Property Amenities" />

				<TABLE titles={["Amenity Category","Subject Property Amenity","Material","Detail"]} widths={[270,270,270,270]} values={lu("14.001-04")} />

				<ADDD values={lu("14.006-10")} subtitle="(Subject Property Amenities)" /> 

				<COMMENTARY title="Subject Property Amenities Commentary" value={lu("14.011")} />

				<EXHIBITS title="Subject Property Amenities Exhibits" values={lu("14.099")} />


				<TAB title="Overall Quality and Condition" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Overall Quality" value={lu("15.000")} />
						<OVERALL_LIST value={lu("15.001")} />
					</div>
					<div>
						<TXR_B title="Overall Condition" value={lu("15.005")} />
						<OVERALL_LIST value={lu("15.006")} />
					</div>
				</div>

				<COMMENTARY title="Reconciliation of Overall Quality and Condition" value={lu("15.010")} />

				<TAB title="Highest and Best Use" />

				<TX_BI title="Is the present use of the subject property …" value=" " />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Legally Permissible" value={lu("16.000")} />
						<TXR_B title="Physically Possible" value={lu("16.001")} />
					</div>
					<div>
						<TXR_B title="Financially Feasible" value={lu("16.002")} />
						<TXR_B title="Maximally Productive" value={lu("16.003")} />
					</div>
				</div>

				<CK title="Is the highest and best use of the subject property as improved (or as proposed per plans and specifications) the present use?" value={lu("16.004")} yn />

				<COMMENTARY title="Highest and Best Use Commentary" value={lu("16.005")} />

				<EXHIBITS title="Highest and Best Use Exhibits" id={["HighestAndBestUseExhibit"]} />


				<TAB title="Market" />

				<TXC_B title="Market Area Boundary" value={lu("17.003")} />
				<TXC_B title="Search Criteria Description" value={lu("17.004")} />
				<H1 title="Search Result Metrics" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Active Listings" value={lu("17.005")} />
						<TXR_I title="Median Days on Market" value={lu("17.006")} />
						<TXR_I title="Lowest List Price" value={lu("17.007")} />
						<TXR_I title="Median List Price" value={lu("17.008")} />
						<TXR_I title="Highest List Price" value={lu("17.009")} />
						<TXR_B title="Pending Sales" value={lu("17.010")} />
					</div>
					<div>
						<TXR_B title={`Sales in Past ${lu("17.011")} Months`} value={lu("17.012")} />
						<TXR_I title="Lowest Sale Price" value={lu("17.013")} />
						<TXR_I title="Median Sale Price" value={lu("17.014")} />
						<TXR_I title="Highest Sale Price" value={lu("17.015")} />
						<TXR_B title="Distressed Market Competition" value={lu("17.016")} />
						<TXR_B title="Graph" value={lu("17.017")} />
						<TXR_B title="Price Trend Source" value={lu("17.018")} />
					</div>
				</div>
				<TXC_B title="Price Trend Analysis Commentary" value={lu("17.019")} />

				<H1 title="Housing Trends" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Demand/Supply" value={lu("17.021")} />
					</div>
					<div>
						<TXR_B title="Marketing Time" value={lu("17.022")} />
					</div>
				</div>

				<COMMENTARY title="Market Commentary" value={lu("17.023")} />

				<EXHIBITS title="Market Exhibits" values={lu("17.099")} />

				{ (global.ptr.bInProject || global.ptr.bPUD) &&
				<>
				<TAB_PROJECT title="Project Information" />

				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Project Name" value={lu("18.004")} />
						<TXR_B title="Project Information Data Source" value={lu("18.005")} />
						<TXR_B title="Total Units" value={lu("18.006")} />
						<TXR_I title="Units Sold" value={lu("18.007")} />
						<TXR_I title="Units for Sale" value={lu("18.008")} />
						<TXR_I title="Units Rented" value={lu("18.009")} />
						<TXC_B1 title="Reason Units Rented is Estimated" value={lu("18.010")} />
						<TXR_B title="Mandatory Fees (HOA, PUD, or Co-op)" value=" " />
						<TXR_I title="Monthly Amount" value={lu("18.011")} />
						<TXR_I title={"Common Amenities/\nServices Included"} value={lu("18.012")} />
						<TXR_I title="Utilities Included" value={lu("18.013")} />
						{ global.ptr.bInProject &&
						<>
							<CK1 title="Observed Deficiencies" value={lu("18.014")} yn />
							<TXC_B1 title="Description of Deficiencies" value={lu("18.015")} />
						</>
						}
					</div>
					<div>
						{ global.ptr.bInProject &&
						<>
						<TXR_B title="Project Completeness" value=" " />
						<CK1_I title="Are units, common areas, and amenities in project complete?" value={lu("18.016")} nobold yn />
						<CK1_I title="Subject Property Building Complete" value={lu("18.017")} nobold />
						<CK1_I title="Converted in Past 3 Years" value={lu("18.018")} nobold />
						<CK1 title="Ground Rent" value={lu("18.019")} />
						<TXR_I title="Annual Amount" value={lu("18.020")} />
						<TXR_I title="Expires" value={lu("18.021")} />
						<TXC_B1 title="Description of Ground Rent" value={lu("18.022")} />
						</>
						}
					</div>
				</div>

				{ global.ptr.bCooperative && global.ptr.subProj.projectFinancialInformation.projectBlanketFinancingIndicator &&
				<>
					<H1 title="Cooperative Information" />
					<div className='col2 mt-3'>
						<div>
							<TXR_B title="Shares Issued and Outstanding" value={lu("18.023")} />
							<TXR_B title={"Shares Attributable to Subject\nProperty"} value={lu("18.024")} />
						</div>
						<div>
							<TXR_B title="Proprietary Lease Expires" value={lu("18.025")} />
						</div>
					</div>
					<CK_H2 title="Project Blanket Financing" value={lu("18.026")} />
					<TXR_B title="Pro Rata Share" value={lu("18.027")} />
	
					<TABLE titles={lu("18.028")} widths={[216,216,216,216,216]} values={lu("18.029-63")} />
				</>
				}

				<H1 title="Project Factors and Impact to Value/Marketability" />
				<TABLE titles={["Project Factor","Detail","Impact","Comment"]} widths={[270,270,112,428 ]} values={lu("18.064-93")} />

				<TXC_B title="Project Factors Commentary" value={lu("18.094")} />

				<COMMENTARY title="Project Information Commentary" value={lu("18.095")} />

				<EXHIBITS title="Project Information Exhibits" id={["ProjectAmenity","ProjectDeficiency","ProjectExhibit"]} />
				</>
				}

				<TAB title="Subject Listing Information" tx="Current and/or relevant listings of the subject property (minimum 1 year look back)" />

				{  !(global.ptr.subProp.listingInformationSummary.listedWithinPreviousYearIndicator ?? false) &&
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Current or Relevant Listings" value={lu("19.000")} />
						<TXR_I title="Data Source" value={lu("19.001")} />
					</div>
				</div>
				}

				{  ((global.ptr.subProp.listingInformationSummary.listedWithinPreviousYearIndicator ?? false) && global.ptr.subProp.listingInformations.length > 0 ) &&
				<>
					<TABLE titles={["Listing Status","Listing Type","Listing ID","Start Date","End Date","DOM","Starting List Price","Current or Final List Price"]} widths={[135,135,135,135,135,135,135,135]} values={lu("19.002-09")} />
					<TB_SUB_H1_R title="Total DOM" offset={540} width={270} value={lu("19.010")} />
				</>
				}

				<TXC_B title="Analysis of Subject Property Listing History" value={lu("19.011")} />
				<EXHIBITS title="Subject Listing Information Exhibits" id={["SubjectListingExhibit"]} />

				{ lu("20.000") &&
					<>
					<TAB title="Sales Contract" />
					<div className='col2 mt-3'>
						<div>
							<CK1 title="Is there a sales contract?" value={lu("20.000")} yn />
							<CK1 title="Was sales contract information analyzed?" value={lu("20.001")} />
							<CK1 title="Does this appear to be an arm’s length transaction?" value={lu("20.002")} />
							<TXC_B1 title="Non-Arm’s Length Commentary" value={lu("20.003")} />
						</div>
						<div>
							<TXR_B title="Contract Price" value={lu("20.004")} />
							<TXR_B title="Contract Date" value={lu("20.005")} />
							<TXR_B title="Transfer Terms" value={lu("20.006")} />
							<TXR_B title="Personal Property Conveyed" value={lu("20.007")} />
							{ (lu("20.007") === "Yes") &&
							<TXC_I1 comment="Personal property is not included in the appraiser’s final opinion of value"S />
							}
						</div>
					</div>

					<H1_TX title="Financial Sales Concessions" value="Financial assistance paid by or on behalf of the seller as an inducement to purchase the subject property" />
					<TXR_B title="Known Sales Concessions" value={lu("20.008")} />
					<TXR_B title="Total Sales Concessions" value={lu("20.009")} />
					<TXR_I title="Typical for Market" value={lu("20.010")} />

					<COMMENTARY title="Sales Contract Analysis" value={lu("20.011")} />
					<EXHIBITS title="Sales Contract Exhibits" id={["SalesContractExhibit"]} />
					</>
				}

				<TAB title="Prior Sale and Transfer History" />

				<H1 title="Subject Transfer History" />
				<TXC_I comment="Prior sales and/or transfers of the subject property (minimum 3 year look back)" />
				<TXR_B title="Prior Sales or Transfers" value={lu("21.000")} />
				<TXR_I title="Data Source" value={lu("21.001")} />

				<TABLE titles={["Transfer Terms","Date","Amount","Data Source"]} widths={[270,270,270,270]} values={lu("21.002-05")} />
				<TXC_B title="Analysis of Prior Sale and Transfer History of Subject Property" value={lu("21.006")} />

				<H1 title="Comparable Transfer History" />
				<TXC_I comment="Prior sales and/or transfers of the comparable properties from the ‘Sales Comparison Approach’ section (minimum 1 year look back)" />

				<TABLE titles={["#","Transfer Terms","Date","Amount","Data Source"]} widths={[36,261,261,261,261]} values={lu("21.007-11")} />
				<TXC_B title="Analysis of Prior Sale and Transfer History of Comparable Sales" value={lu("21.012")} />

				<EXHIBITS title="Prior Sale and Transfer History Exhibits" id={["PriorSaleAndTransferHistoryExhibit"]} />

				<SALES_COMPARISON />
				<RENTAL_INFORMATION />
				<INCOME_APPROACH />
				<COST_APPROACH />

				<TAB title="Reconciliation" />
				<H1 title="Approaches to Value" />
				<TABLE titles={["","Sales Comparison Approach","Income Approach","Cost Approach"]} widths={[270,270,270,270]} values={lu("26.000-05")} />

				<H1 title="Appraisal Summary" />
				<div className='col2 mt-3'>
					<div>
						<TXR_B title="Contract Price" value={lu("26.006")} />
						<TXR_B title="Opinion of Market Value" value={lu("26.007")} />
						<TXR_I title="Pro Rata Share Calculation Method" value={lu("26.008")} />
						<TXR_B title="Market Value Condition" value={lu("26.009")} />
					</div>
					<div>
						<TXR_B title="Reasonable Exposure Time" value={lu("26.010")} />
						<TXR_B title="Effective Date of Appraisal" value={lu("26.011")} />
						<TXR_B title="FHA REO Insurability Level" value={lu("26.012")} />
					</div>
				</div>
				<TXC_B title="Final Value Condition Statement" value={lu("26.013")} />

				{ (global.ptr.bCooperative || global.ptr.bCondop) &&
				<TXC_I comment="The market value represents the cooperative interest. The cooperative interest is the equity portion that is over and above the pro rata share of the blanket mortgage(s)." />
				}

				{ global.ptr.valRecon.valuationReconciliationDetail.additionalClientRequestedConditionsIndicator &&
				<>
					<H1 title="Client Requested Conditions" />
					<TABLE titles={["Value Condition","Marketing or Exposure Time","Duration","Alternate Opinion of Value"]} widths={[270,270,270,270]} values={lu("26.014-17")} />
					<TXC_B title="Requested Condition Commentary" value={lu("26.018")} />
				</>
				}

				<COMMENTARY title="Reconciliation of Market Value" value={lu("26.019")} />

				<ADDD_SUMMARY actionableOnly={false} /> 

				<div className='col2 mt-3'>
					<div>
						{ !h.isEmpty(lu("26.071")) &&
						<>
							<TXR_B title="As Is Overall Condition Rating" value={lu("26.071")} />
							<TXC_I1 comment="Existing condition of the property as of the effective date of this appraisal, excluding all required repairs, alterations, or inspections" />
						</>
						}
					</div>
					<div>
						<TXR_B title={"Total Estimated Cost of Items\nRecommended for Repair"} value={lu("26.072")} />
					</div>
				</div>

				<EXHIBITS title="Reconciliation Exhibits" id={["ReconciliationExhibit"]} />

				{ (global.ptr.valRpt.valuationRevisions.length > 0) &&
				<>
					<TAB title="Revision History" />
					<TABLE titles={["Revision Date","URAR Section","Description"]} widths={[263,263,554]} values={lu("27.000-02")} />

					{ global.ptr.valRpt.valuationReportDetail.reconsiderationOfValueIndicator &&
						<>
						<H1 title="Reconsideration of Value" />
						<div className='col2 mt-3'>
							<div>
								<TXR_B title="Type" value={lu("27.003")} />
								<TXR_B title="Date" value={lu("27.004")} />
							</div>
							<div>
								<TXR_B title="Result" value={lu("27.005")} />
							</div>
						</div>
						<TXC_B title="Reconsideration of Value Commentary" value={lu("27.006")} />
						</>
					}
				</>
				}

				<TAB title="Supplemental Information" />
				<EXHIBITS title="Supplemental Information Exhibits" id={["SupplementalExhibit"]} />

				<div className='hr-2 mt-10 mb-10' />

				<END_NOTES />
				<SIGNATURE />

				<div className='h-10'></div>
			</div>
		</div>
		</>
	)
}

